var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { Asterisk } from '../';
import { getValue } from './utils';
import useKeyboardEscapeHandler from '../hooks/useKeybordEscapeHandler';
var useStyles = makeStyles(function (theme) {
  return {
    content: _extends({
      borderRadius: 3,
      boxSizing: 'border-box',
      listStyleType: 'none',
      maxWidth: 270,
      padding: 0,
      margin: 0
    }, theme.typography.body1),
    flags: _extends({
      borderBottom: '1px dotted',
      borderColor: 'inherit',
      margin: theme.spacing(0, 0.5),
      whiteSpace: 'nowrap',
      display: 'inline',
      fontWeight: 'bold',
      fontStyle: 'normal',
      position: 'relative',
      top: '-4px'
    }, R.pathOr({}, ['mixins', 'table', 'flag'], theme)),
    svg: {
      verticalAlign: 'middle'
    },
    header: {
      color: theme.palette.getContrastText(theme.palette.primary.main)
    }
  };
});
var Flags = function Flags(_ref) {
  var _cx;
  var _ref$flags = _ref.flags,
    flags = _ref$flags === undefined ? [] : _ref$flags,
    isHeader = _ref.isHeader,
    HTMLRenderer = _ref.HTMLRenderer,
    labelAccessor = _ref.labelAccessor;
  var classes = useStyles();
  var noFlags = R.isNil(flags) || R.isEmpty(flags);
  var _useKeyboardEscapeHan = useKeyboardEscapeHandler(),
    open = _useKeyboardEscapeHan.open,
    setOpen = _useKeyboardEscapeHan.setOpen;
  if (noFlags) return null;
  var hasUncoded = R.any(R.complement(R.has('code')), flags);
  var codedIcons = R.pipe(R.reduce(function (acc, flag) {
    return R.when(R.always(R.has('code', flag)), R.append(flag.code))(acc);
  }, []), R.join(','))(flags);
  var labels = R.map(function (flag) {
    var value = getValue(labelAccessor)(flag);
    return R.isEmpty(labelAccessor(flag)) ? value.label : labelAccessor(flag) + ': ' + value.label;
  }, flags);
  var content = React.createElement('ul', {
    'data-testid': 'cell-flags-footnotes-content',
    className: classes.content
  }, R.addIndex(R.map)(function (label, index) {
    return React.createElement('li', {
      key: index
    }, R.is(Function, HTMLRenderer) ? React.createElement(HTMLRenderer, {
      html: label
    }) : label);
  }, labels));
  return React.createElement(Tooltip, {
    tabIndex: 0,
    'aria-label': R.join(', ', labels),
    'aria-hidden': false,
    title: content,
    placement: 'top',
    open: open,
    interactive: true,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      return setOpen(false);
    }
  }, React.createElement('span', {
    'data-testid': 'cell-flags-footnotes-icon',
    className: cx(classes.flags, (_cx = {}, _cx[classes.header] = isHeader, _cx))
  }, R.not(R.isEmpty(codedIcons)) && codedIcons, R.and(R.not(R.isEmpty(codedIcons)), hasUncoded) && React.createElement(React.Fragment, null, ','), hasUncoded && React.createElement(Fragment, null, '\xA0', React.createElement(Asterisk, {
    className: classes.svg,
    style: {
      fontSize: 11
    }
  }), React.createElement(Typography, {
    variant: 'srOnly'
  }, '* ' + labels))));
};
Flags.propTypes = process.env.NODE_ENV !== "production" ? {
  flags: PropTypes.array,
  isHeader: PropTypes.bool,
  HTMLRenderer: PropTypes.func,
  labelAccessor: PropTypes.func
} : {};
export default Flags;